import React, {useEffect, useRef, useState} from 'react';
import {Col, Form, message, Row} from 'antd';
import ProForm, {ProFormInstance} from '@ant-design/pro-form';
import {WdiCardTitle, wdiCore, WdiInput} from '@/components/WdiControls';
import {BOHQ} from '@/services/mdm/bohq';
import {FileUploadUtility, WdiFileList} from '@/components/WdiControls/WdiFileUpload';
import DataStore from '@/components/GridWidget/DataStore';
import {FormPageProps} from '@/components/WdiBus/FormPage';
import {WdiPanel} from '@/components/WdiControls/WdiPanel';
import {DataOptions} from '@/services/basic/metadata';
import {EC} from '@/services/mdm/ec';
import {Product} from '@/services/mdm/product';
import {ResponseStatus} from '@/utils/request';
import {initDisplyPageContext, ViewEntityProps} from '../../components/data';
import {FormBPDetailsForApprovalPanel} from '../../GeneralProjectApply/components/details';
import {BudgetProjectDetail} from '@/services/sales/bp/budgetProject';
import FormBPHistoryPanel from '../../components/history';
import {FormBudgetProject} from '@/services/sales/bp/formBudgetProject';
import {WdiButtonContainer} from '@/components/WdiBus/Buttons';
import {BPMoreWapper} from './Button';
import {Enum} from '@/enums/system';
import {NSToken} from '@/services/identity';
import {SoldTo} from '@/services/mdm/soldto';
import {CustSys} from '@/services/mdm/custsys';
import {Staff} from '@/services/basic/staff';
import {WdiEditor} from "@/components/WdiControls/WdiEditor";

const BudgetProjectDisplayApp: React.FC<FormPageProps> = (props) => {
  const formRef = useRef<ProFormInstance>();
  const [budgetProjectDetail, setBudgetProjectDetail] = useState<any[]>([]);
  const [formBPHistory, setFormBPHistory] = useState<any[]>([]);
  const [entity, setEntity] = useState<ViewEntityProps>();

  useEffect(() => {
    (async () => {
      const params = props.data;
      if (params) {
        const result = await initDisplyPageContext(params);
        if (result.code !== ResponseStatus.SUCCESS) {
          message.error(result.message);
          return;
        }
        const viewEntity: ViewEntityProps = result.data;
        const { budgetProject } = viewEntity;
        if (budgetProject) {
          formRef.current?.setFieldsValue({
            projectName: budgetProject?.projectName,
            projectCode: budgetProject?.projectCode,
            projectDate: wdiCore.Date.Join(
              budgetProject?.projectStartDate,
              budgetProject?.projectEndDate,
            ),
            totalBudget: wdiCore.Number.AmountToString(budgetProject?.totalBudget),
            fileInfo: FileUploadUtility.parse(budgetProject?.fileName, budgetProject?.filePath),
            projectRemark: budgetProject?.projectRemark,
            applyDate: wdiCore.Date.Join(
              budgetProject?.applyStartDate,
              budgetProject?.applyEndDate,
            ),
          });
        }
        setEntity(viewEntity);

        if (budgetProject?.projectApproverIds) {
          Staff.search({ staffIds: budgetProject?.projectApproverIds }).then((response) => {
            formRef.current?.setFieldsValue({
              projectApproverIds: response.data
                .map((item) =>
                  wdiCore.String.GenerateLabelDescription(item.staffNoOrName, item.title),
                )
                .join(),
            });
          });
        }
        if (budgetProject?.bohqId) {
          BOHQ.get(budgetProject.bohqId).then((response) => {
            formRef.current?.setFieldsValue({
              bohqName: response.data.bohqName,
            });
          });
        }
        if (budgetProject?.limitedEcIds) {
          EC.search({ ecIds: budgetProject.limitedEcIds }).then((response) => {
            formRef.current?.setFieldsValue({
              limitedEcIds: response.data.map((item) => item.ecName).join(),
            });
          });
        }
        if (budgetProject?.limitedProductIds) {
          Product.searchAll({ productIds: budgetProject.limitedProductIds }).then((response) => {
            formRef.current?.setFieldsValue({
              limitedProductIds: response.data.map((item) => item.productName).join(),
            });
          });
        }
        if (budgetProject?.limitedSoldToCodes) {
          SoldTo.search({ soldToCodes: budgetProject?.limitedSoldToCodes }).then((response) => {
            if (response.data && response.data.length > 0) {
              formRef.current?.setFieldsValue({
                limitedSoldToCodes: response.data.map((soldTo) => soldTo.codeOrName).join(),
              });
            }
          });
        }
        if (budgetProject?.limitedCustSysCodes) {
          CustSys.search({custSysCodes: budgetProject?.limitedCustSysCodes}).then((response) => {
            if (response.data && response.data.length > 0) {
              formRef.current?.setFieldsValue({
                limitedCustSysCodes: response.data.map((custSys) => custSys.codeOrName).join(),
              });
            }
          });
        }
        if (budgetProject?.limitedActivitySubjectIds) {
          DataOptions.search({
            typeGroup: 121,
            inValues: budgetProject?.limitedActivitySubjectIds
          }).then(response => {
            if (response.data && response.data.length > 0) {
              formRef.current?.setFieldsValue({
                limitedActivitySubjectIds: response.data.map(limitedActivity => limitedActivity.name).join()
              });
            }
          });
        }

        if (budgetProject) {
          BudgetProjectDetail.query(budgetProject?.budgetProjectId, NSToken.getBu()).then(
            (response) => {
              setBudgetProjectDetail(DataStore.init(response.data));
            },
          );
          FormBudgetProject.getHistory(budgetProject?.budgetProjectId, budgetProject?.buId).then(
            (response) => {
              setFormBPHistory(DataStore.init(response.data));
            },
          );
        }
      }
    })();
  }, [props.data]);

  useEffect(() => {
    if (props.setPageTitle && entity) {
      let title = `专项项目详情`;
      DataOptions.search({ typeGroup: 12, value: entity.budgetProject?.projectStatusId }).then(
        (response) => {
          if (response.code !== ResponseStatus.SUCCESS) {
            message.error(response.message);
            return;
          }
          if (response.data && response.data.length > 0) {
            title += `【${response.data[0].name}】`;
            if (props.setPageTitle)
              props.setPageTitle(
                <div>
                  <span>{title}</span>
                  <WdiButtonContainer>
                    <BPMoreWapper
                      onClose={props.onClose}
                      callback={props.callback}
                      budgetProjectId={entity?.budgetProject?.budgetProjectId}
                      year={entity?.budgetProject?.year}
                    />
                  </WdiButtonContainer>
                </div>,
              );
          }
        },
      );
    }
  }, [props.setPageTitle, entity]);

  return (
    <>
      <ProForm
        formRef={formRef}
        submitter={{
          render: () => {
            return <></>;
          },
        }}
      >
        <WdiPanel
          title={<WdiCardTitle iconType={Enum.IconType.BASE_INFO} title="项目基本信息" />}
          collapsed={true}
        >
          <Row gutter={[16, 24]}>
            <Col className="gutter-row" span={4}>
              <Form.Item name="projectName" label="项目名称">
                <WdiInput readOnly />
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={4}>
              <Form.Item name="projectCode" label="项目编号">
                <WdiInput readOnly />
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={4}>
              <Form.Item name="projectDate" label="活动实际执行期间">
                <WdiInput readOnly/>
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={4}>
              <Form.Item name="totalBudget" label="项目总额">
                <WdiInput readOnly />
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={4}>
              <Form.Item name="projectApproverIds" label="活动申请/核销附加审批人">
                <WdiInput readOnly/>
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={4}>
              <Form.Item name="bohqName" label="预算归属">
                <WdiInput readOnly />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 24]}>
            <Col className="gutter-row" span={16}>
              <Form.Item name="projectRemark" label="方案简述">
                <WdiEditor readOnly={true} />
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={8}>
              <Form.Item
                name="fileInfo"
                label="附件"
                valuePropName="fileList"
                getValueFromEvent={(e: any) => {
                  return e.fileList || [];
                }}
              >
                <WdiFileList
                  fileList={FileUploadUtility.parse(
                    entity?.formBudgetProject?.fileName,
                    entity?.formBudgetProject?.filePath,
                  )}
                />
              </Form.Item>
            </Col>
          </Row>
        </WdiPanel>
        <WdiPanel
          title={<WdiCardTitle iconType={Enum.IconType.LIMITED_INFO} title="维度信息（对专项下的活动申请做限制）"/>}
          collapsed={true}
        >
          <Row gutter={[16, 24]}>
            <Col className="gutter-row" span={4}>
              <Form.Item name="applyDate" label="专项费用可申请时间">
                <WdiInput readOnly/>
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={4} hidden={true}>
              <Form.Item name="limitedProductIds" label="产品别维度">
                <WdiInput readOnly/>
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={4} hidden={true}>
              <Form.Item name="limitedEcIds" label="费用项维度">
                <WdiInput readOnly/>
              </Form.Item>
            </Col>

            <Col className="gutter-row" span={4}>
              <Form.Item name="limitedCustSysCodes" label="客户组维度">
                <WdiInput readOnly/>
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={4}>
              <Form.Item name="limitedSoldToCodes" label="客户维度">
                <WdiInput readOnly/>
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={4}>
              <Form.Item name="limitedActivitySubjectIds" label="活动主题维度">
                <WdiInput readOnly/>
              </Form.Item>
            </Col>
          </Row>
        </WdiPanel>
        <FormBPDetailsForApprovalPanel dataSource={budgetProjectDetail} />
        <FormBPHistoryPanel dataSource={formBPHistory} />
      </ProForm>
    </>
  );
};
export default BudgetProjectDisplayApp;
